import {
  HeaderProfile,
  Section,
  SkeletonBox,
  CardItem,
  Container,
  CardItemContainer,
  CardItemWrapper
} from '@presentation/components';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import * as Styled from './styled';
import separatorBlueBottom from '../../assets/marker-section-bot.svg';
import type { PageSkeletonProps } from './types';

export const PageSkeleton: FC<PageSkeletonProps> = (props) => {
  const { backLink } = props;

  return (
    <>
      <RootStyled.HeaderWrapper>
        <HeaderProfile
          title='Article'
          backLink={backLink}
        />
        <RootStyled.SeparatorBottom src={separatorBlueBottom} />
      </RootStyled.HeaderWrapper>

      <Styled.ButtonsWrapper>
        <SkeletonBox style={{ width: '20%', height: '30px' }} />
        <SkeletonBox style={{ width: '20%', height: '30px' }} />
        <SkeletonBox style={{ width: '20%', height: '30px' }} />
      </Styled.ButtonsWrapper>

      <Container>
        <SkeletonBox style={{ width: '100%', height: '300px', margin: '50px auto' }} />
      </Container>

      <Container>
        <CardItem
          loading
          content={{
            title: <SkeletonBox style={{ width: '100%', height: 21.5, display: 'block', marginBottom: 10 }} />,
            text: <SkeletonBox style={{ width: '100%', height: '200px', display: 'block', marginBottom: 10 }} />,
          }}
        />
      </Container>

      <RootStyled.ArticlesWrapper>
        <Container>
          <SkeletonBox style={{ width: '20%', height: '30px' }} />
          <Section>
            <CardItemContainer>
              {Array(8)
                .fill(undefined)
                .map((_, index) => (
                  <CardItemWrapper key={index}>
                    <CardItem
                      key={index}
                      loading
                      content={{
                        title: <SkeletonBox style={{ width: '100%', height: 21.5, display: 'block', marginBottom: 10 }} />,
                        text: <SkeletonBox style={{ width: '100%', height: 21.5, display: 'block', marginBottom: 10 }} />,
                      }}
                    />
                  </CardItemWrapper>
              ))}
            </CardItemContainer>
          </Section>
        </Container>
      </RootStyled.ArticlesWrapper>

      <SkeletonBox style={{ width: '100%', height: '200px', margin: '0 auto' }} />
    </>
  );
};
